const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlipHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,216.81,116.86,128,0,39.19ZM13.92,67.25,93.86,128,13.92,188.75Z",
    style: {
      fill: "#10216f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,128,256,216.81V39.19Zm102.94,60.75L162.14,128l79.94-60.75Z",
    style: {
      fill: "#10216f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.29,
    y: 45.05,
    width: 11.93,
    height: 165.91,
    style: {
      fill: "#10216f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlipHorizontal);
export default __webpack_public_path__ + "static/media/icon-flip-horizontal.b8007d98.svg";
export { ForwardRef as ReactComponent };